import { Container } from "@material-ui/core";
import React from "react";
import Mission from "../../../assets/img/About-Images/mission.jpg";
import "./our-mission.scss";
import { Fade } from "react-reveal";

export default function RealHome(props) {
  return (
    <div id="our-mission">
      <Container>
        <div className="rl-container">
          <img className="picture-div" src={props.img} alt="square" />
          <Fade left cascade>
            <div className="text-div ">
              <h2>{props.title}</h2>
              <p>{props.desc}</p>
            </div>
          </Fade>
        </div>
      </Container>
    </div>
  );
}
